export enum ShuttleMagnetCount {
  Two = 'Two',
  Three = 'Three',
}
